export const formatPercentage = (value?: number | null, fractionDigits = 0, addPercentSymbol = true) => {
  if (value === undefined || value === null) return ``
  return `${(value * 100).toFixed(fractionDigits)}${addPercentSymbol ? `%` : ``}`
}
